<template>
  <div>
  <h1 :class="{'red-color': enable}" @click="enable = !enable">This is About!</h1>
  <hr>
  <button @click="addnum()">clicked {{ num }} times</button>
  <ul>
    <li v-for="student in students" :key="student.sno" class="per-tab">
      <router-link :to="`/about/detail/${student.sno}`">
        {{student.sname}}
      </router-link>
    </li>
  </ul>
  <router-view></router-view>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'About',
  data () {
    return {
      enable: true
    }
  },
  methods: {
    ...mapMutations(['addnum'])
  },
  computed: {
    ...mapState(['num', 'students'])
  }
}
</script>

<style scoped>
.red-color {
  color: red;
}
.per-tab:hover {
    color: #787878;
    background-color: rgba(255, 255, 255, .8);
  }
.per-tab {
  display: inline-block;
  width: 120px;
  line-height: 32px;
  border-left: 1px solid #ccc;
  border-top: 1px solid #ccc;
}
.per-tab:last-child {
  border-right: 1px solid #ccc;
}
</style>



// WEBPACK FOOTER //
// src/pages/About.vue